module.exports = __webpack_public_path__ + "static/media/bearcam.4aa371d2.gif";